import XayDungKeHoach from "./Components/xay-dung-ke-hoach/XayDungKeHoach";
import ChiDaoTuyenDuoi from "./Components/chi-dao-tuyen-duoi/ChiDaoTuyenDuoi";
import ChuyenGiaoKyThuat from "./Components/chuyen-giao-ky-thuat/ChuyenGiaoKyThuat";
import CoSoKBCB from "./Components/co-so-kb-cb/CoSoKBCB";
import HoTroKyThuatChuyenMon from "./Components/ho-tro-ky-thuat/HoTroKyThuatChuyenMon";
import HoiChanKhamBenh from "./Components/hoi-chan-kham-benh/HoiChanKhamBenh";

export const danhSachTabKhoVatTu = (typeKho?: any, listCodeCN?: any) => [
  // {
  //   eventKey: "0",
  //   title: "Xây dựng kế hoạch",
  //   component: <XayDungKeHoach
  //     // materialsGroup={MATERIALS_GROUP.VAT_TU}
  //     // warehouseId={typeKho?.id}
  //     className="h-bang-ds-phieu-ke-hoach"
  //   />,
  // },
  // {
  //   eventKey: "1",
  //   title: "Chỉ đạo tuyến dưới",
  //   component: <ChiDaoTuyenDuoi
  //     // materialsGroup={MATERIALS_GROUP.VAT_TU}
  //     // warehouseId={typeKho?.id}
  //     className="h-bang-ds-phieu-ke-hoach"
  //   />,
  // },
  // {
  //   eventKey: "2",
  //   title: "Chuyển giao kỹ thuật",
  //   component: <ChuyenGiaoKyThuat/>,
  // },
  {
    eventKey: "3",
    title: "Chuyển giao kỹ thuật",
    component: <CoSoKBCB
      className="h-bang-ds-phieu-ke-hoach"
    />,
  },
  {
    eventKey: "4",
    title: "Hỗ trợ kỹ thuật chuyên môn",
    component: <HoTroKyThuatChuyenMon
      className="h-bang-ds-phieu-ke-hoach"
    />,
  },
  {
    eventKey: "5",
    title: "Hội chẩn KCB từ xa",
    component: <HoiChanKhamBenh
      className="h-bang-ds-phieu-ke-hoach"
    />,
  },
];


export {};